import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { href: '#channel', label: '栏目导览' },
  { href: '#boundary', label: '尺度边界' },
  { href: '#cases', label: '违规案例' },
  { href: '#reasons', label: '下架原因' },
  { href: '#checklist', label: '发布自查' },
  { href: '#faq', label: '审核问答' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-scales-3-line text-lg" />
          </span>
          <span className={`flex items-baseline gap-1 font-serif text-lg font-black tracking-wide ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
            51擦边
            <i className="ri-arrow-right-up-line text-primary-500 text-sm" />
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  : 'text-background-50/85 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#faq"
            className={`hidden whitespace-nowrap items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors sm:flex ${
              scrolled ? 'bg-primary-500 text-background-50 hover:bg-primary-600' : 'bg-background-50 text-primary-600 hover:bg-accent-100'
            }`}
          >
            快速查规则
            <i className="ri-arrow-right-line text-sm" />
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className={`flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
              scrolled ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {NAV_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              快速查规则
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}